import axiosClient from "../../../../../../api/axiosClient";

const materialLookupService = {

  searchRawMaterial: async (search) => {

    const res = await axiosClient.get(
      `/api/ppe/masters/raw-materials/search?search=${encodeURIComponent(search)}`
    );

    return res.data?.data || [];
  }

};

export default materialLookupService;